<template>
  <a-spin
    :spinning="loading"
    tip="Preparing To Show Data ...  "
    v-if="loading"
  />
  <div v-else>
    <a-card>
      <div slot="title" class="profileHead">
        <a-row slot="title" class="m-width-full">
          <a-col :xs="{ span: 24 }" :lg="{ span: 18 }">
            <!-- <div class="ttlbg"></div> -->
            <img
            keep-alive
            class="m-drawer-brand"
            src="@/assets/logo.png"
            alt="brand"
          />
            <span style="vertical-align: bottom;">Change logs</span>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <a-input placeholder="Search" v-model="search" @change="onChange" style="color: rgba(0, 0, 0, 0.65)!important;"></a-input>
          </a-col>
        </a-row>
        
      </div>
    <a-tree 
      :treeData="source"
      :autoExpandParent="true"
      :defaultExpandedKeys="defaultExpandedKeys"
      :defaultExpandParent="true"
      showLine
    >
    <!-- defaultExpandAll -->
    <b slot="Versiontitle" slot-scope="record">Version {{ record.version }}</b>
    </a-tree>
    </a-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import lodash from 'lodash';
import deepdash from 'deepdash';
const _ = deepdash(lodash);
export default {
  name: "ChangeLogs",
  mixins: [GlobalMethod],
  props: {},
  data() {
    const treeData = [
      {
        title: 'parent 1',
        key: '0-0',
        children: [
          {
            title: 'parent 1-0',
            key: '0-0-0',
            disabled: true,
            children: [
              { title: 'leaf', key: '0-0-0-0', disableCheckbox: true },
              { title: 'leaf', key: '0-0-0-1' },
            ],
          },
          {
            title: 'parent 1-1',
            key: '0-0-1',
            children: [{ key: '0-0-1-0', slots: { title: 'title0010' } }],
          },
        ],
      },
    ];
    return {
      treeData,
      loading: true,
      search: "",
      source: [],
      sourceOri: [],
      columns: [
        {
          title: "No",
          key: "no",
          width: 60,
          align: "center",
          scopedSlots: { customRender: "no" },
          fixed: "left",
        },
        {
          title: "No",
          key: "no",
          width: 60,
          align: "center",
          scopedSlots: { customRender: "no" },
          fixed: "left",
        },
      ],
      defaultexpandedKeys: ["0"],
      expandedKeys: ["0"],
    };
  },
  mounted() {
    this.asyncAxiosGet("public_manifest/versioning",
      this.getAuth,
    ).then((res) => {
      this.source = res.data;
      this.sourceOri = res.data;
      this.loading = false;
    }).catch((err) => {
      this.loading = false;
      let response = Object.assign({}, err.response);
      if (response.data.status == false && response.data.message) {
        this.displayMessageValue("error-other", response.data.message);
      } else {
        let responses = Object.assign({}, err.response.data);
        this.displayMessageValue("error", responses);
      }
    });
  },
  computed: {
    ...mapGetters(["getScreen"]),
    defaultExpandedKeys() {
      let result = [];
      for (let i = 0; i < this.sourceOri[0].children.length; i++) {
        result.push(this.sourceOri[0].children[i].key);
      }
      return result;
    }
  },
  methods: {
    onChange(e) {
      const value = e.target.value;
      this.source = _.filterDeep(this.sourceOri,
        function (o) { return o.title && o.title.toLowerCase().includes(value.toLowerCase()); },
        { childrenPath: 'children' });
    },
  }
};
</script>

<style lang="less">
.ant-layout{
  margin-left:0px!important
}
.ant-card-head-title{
  padding:0px!important;
}
.ant-card-head{
  padding:0px!important;
}
.ant-card-bordered {
  border: none!important;
}
.profileHead {
    padding         : @padding;
    background-image: linear-gradient(to bottom right, @color-primary, darken(@color-primary, 40));
    display         : flex;
    flex-direction  : column;
    flex-wrap       : nowrap;
    align-items     : flex-start;
    justify-content : center;
    line-height     : 1;
    //position        : relative;
    width           : 100%!important;
    position: fixed;
    z-index: 999;

    * {
        color: white;
    }

    // &:after {
    //     content          : '';
    //     position         : absolute;
    //     //background-image : url('~@/assets/Pattern.png');
    //     top              : 0;
    //     right            : -20px;
    //     bottom           : 0;
    //     width            : 100%;
    //     background-repeat: no-repeat;
    //     background-size  : contain;
    //     opacity          : 0.4;
    //     transform: scaleX(-1);
    // }
}

.ttlbg{
  transform: rotate(180deg);
  background-image: url('~@/assets/Pattern.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top center;
  width: 300px;
  height: 300px;
  position: absolute;
  top: -170px;
  left: -10px;
  opacity: 0.4;
}

</style>